// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__3tBAn","title":"FrontImage_title__3ydmw"};